
const common = {
  // Navigation
  brand_story: "Brand Story",
  our_philosophy: "Our Philosophy", 
  product_series: "Product Series",
  global_sourcing: "Global Sourcing",
  start_journey: "Start Journey",
  
  // Hero Section
  hero_title: "Reclaim Your Right to",
  hero_title_highlight: "Youth",
  hero_description: "LunaKey provides nature's most effective superfoods, scientifically crafted to integrate into your daily rituals, allowing you to radiate brilliance and eternal vitality.",
  hero_cta: "Start Your Journey",
  
  // Story Section
  story_title: "From Myth to Modernity",
  story_subtitle: "From Legend to Reality",
  story_description_1: "In ancient legends, Luna goddess danced with spirit deer under moonlight, guarding nature's secrets and life's vitality. This mythical power now transforms into every LunaKey product through precise modern scientific extraction.",
  story_description_2: "We uphold the philosophy of 'Nature Empowers, Science Confirms Rights', transforming the world's most precious superfoods into sources of vitality for your daily life through rigorous scientific processes.",
  story_quote: "We don't fight against time, but reshape your right to feel young within time.",
  
  // Philosophy Section
  philosophy_title: "Our Philosophy",
  philosophy_subtitle: "Trinity value system, building your healthy lifestyle",
  natures_proof: "Nature's Proof",
  natures_proof_subtitle: "Evidence from Nature",
  natures_proof_description: "Globally sourced high-efficiency superfoods with zero artificial additives. Every product carries nature's purest power, rigorously selected and scientifically verified.",
  empowered_confidence: "Empowered Confidence",
  empowered_confidence_subtitle: "Confidence Through Empowerment",
  empowered_confidence_description: "Feel the composure and peace that comes from controlling your own health. When you choose LunaKey, you choose the best investment and care for yourself.",
  your_vitality: "Your Vitality, Your Right",
  your_vitality_subtitle: "Your Energy, Your Authority",
  your_vitality_description: "A manifesto about proactive self-care and health sovereignty. You have the right to your best condition, the right to feel life's infinite vitality.",
  
  // Products Section
  products_title: "Your Rights, Reshaped Here",
  products_subtitle: "Two major product series providing comprehensive support for your health and beauty",
  proof_series: "The Proof Series",
  proof_series_subtitle: "Rights Evidence Collection",
  proof_series_description: "Selected global premium superfoods providing the strongest proof for your health. Every product undergoes strict quality control to ensure you receive the purest nutritional supplementation.",
  declaration_series: "The Declaration Series",
  declaration_series_subtitle: "Energy Manifesto Collection",
  declaration_series_description: "Energy supplementation solutions designed for modern lifestyles, allowing you to maintain optimal condition in busy daily life, showcasing inner radiance and vitality.",
  acai_powder: "Acai Berry Powder",
  acai_description: "Rich in antioxidants, boosts immunity",
  white_tomato: "White Tomato Powder",
  white_tomato_description: "Natural whitening, radiant skin glow",
  glow_booster: "Glow Booster",
  glow_description: "Inside-out cultivation, natural radiance bloom",
  energy_elixir: "Energy Elixir",
  energy_description: "Sustained energy, unleash infinite potential",
  learn_more: "Learn More",
  
  // Sourcing Section
  sourcing_title: "Following the Deer's Path",
  sourcing_subtitle: "Follow the spirit deer's footsteps to explore the world's most precious superfood origins",
  brazil: "Brazil",
  brazil_ingredient: "Acai Berry",
  brazil_description: "Purple gems from deep Amazon rainforest, rich in anthocyanins and antioxidants, nature's gift of youth code.",
  peru: "Peru",
  peru_ingredient: "Maca Root",
  peru_description: "Energy source from Andean highlands, known as 'Peruvian Ginseng' for millennia, infusing the body with lasting vitality.",
  himalaya: "Himalaya",
  himalaya_ingredient: "Goji Berry",
  himalaya_description: "Red treasures from the world's roof, cultivating super vitality in polar environments, natural medicine nourishing body and mind.",
  mediterranean: "Mediterranean",
  mediterranean_ingredient: "Olive Leaf",
  mediterranean_description: "Green essence under Mediterranean sunshine, carrying millennia of health wisdom, bringing pure protection to modern life.",
  
  // Newsletter Section
  newsletter_title: "Receive Your Vitality Renewal Guide",
  newsletter_description: "Subscribe to our exclusive content for the latest health information, product updates, and professional nutritional advice to begin your vitality journey.",
  email_placeholder: "Your email address",
  subscribe: "Subscribe",
  subscribing: "Subscribing...",
  subscribe_success: "Subscription successful! Thank you for joining the LunaKey family.",
  subscribe_error: "Subscription failed, please try again later.",
  privacy_notice: "We promise to protect your privacy and will not share your information with third parties. You can unsubscribe at any time.",
  
  // Footer
  quality_assurance: "Quality Assurance",
  about_us: "About Us",
  contact_us: "Contact Us",
  careers: "Careers",
  faq: "FAQ",
  user_guide: "User Guide",
  customer_service: "Customer Service", 
  return_policy: "Return Policy",
  footer_description: "Reclaim your right to youth, let nature's most effective superfoods integrate into your daily rituals, radiating brilliance and eternal vitality.",
  all_rights_reserved: "All rights reserved",
  privacy_policy: "Privacy Policy",
  terms_of_service: "Terms of Service"
};

export default common;
